import { useFirestore, useAuth } from "../firebase";
import { Locales } from "../locale";
import { Audience } from "../furniture";

export const register = async (
    studyId?: string,
    audience: Audience = Audience.Teen,
) => {
    const auth = useAuth();
    const firestore = useFirestore();
    const {
        // @ts-ignore
        user: { uid, metadata },
    } = await auth().signInAnonymously();

    const me: any = {
        uid,
        createdAt: new Date(metadata.creationTime),
        language: "en",
        locale: Locales.EN_US,
        theme: "darkTheme",
        audience,
    };

    if (studyId) {
        me.studyId = studyId;
    }

    await firestore().collection("users").doc(uid).set(me);
};

export const logout = async () => {
    const auth = useAuth();
    await auth().signOut();
};

export default {
    logout,
    register,
};
